export const ANALYTICS_EVENT_TYPES = {
  LOGIN: 'login',
  LICENSE_ACTIVATED: 'license-activated',
  MODULE_ACCESSED: 'module-accessed',
  NODE_ACCESSED: 'node-accessed',
  MEDIALINK_ACCESSED: 'medialink-accessed',
  APP_ACCESSED: 'app-accessed',
  DIGIBOOK_ACCESSED: 'digibook-accessed',
  DIGIBOOK_PAGE_ACCESSED: 'digibook-page-accessed',
  USER_MATERIAL_CREATED: 'user-material-created',
  USER_MATERIAL_ACCESSED: 'user-material-accessed',
  USER_WHITEPAGE_CREATED: 'user-whitepage-created',
  USER_WHITEPAGE_ACCESSED: 'user-whitepage-accessed',
} as const;

export const ANALYTICS_EVENT_LOCATIONS = {
  PORTAAL: 'portaal',
  CODEX: 'codex',
} as const;

export const ANALYTICS_EVENT_SUBLOCATIONS = {
  PORTAAL_MATERIAL: 'portaal-material',
  PORTAAL_CATALOG: 'portaal-catalog',
  PORTAAL_DASHBOARD: 'portaal-dashboard',
  PORTAAL_MODULE_DASHBOARD: 'portaal-module-dashboard',
  PORTAAL_MY_ASSIGNMENTS: 'portaal-my-assignments',
  PORTAAL_MODULE_ASSIGNMENTS: 'portaal-module-assignments',
  PORTAAL_TEACHER_ASSIGNMENTS: 'portaal-teacher-assignments',
  PORTAAL_SEARCH: 'portaal-search',
  PORTAAL_RESULTS: 'portaal-results',
  PORTAAL_EXERCISE: 'portaal-exercise',
  PORTAAL_EXERCISE_THEME: 'portaal-exercise-theme',
  PORTAAL_EXERCISE_BOOK: 'portaal-exercise-book',
  PORTAAL_BOOK_SWITCHER: 'portaal-book-switcher',
  CODEX_SIDEBAR_ARROWS: 'codex-sidebar-arrows',
  CODEX_SIDEPANEL: 'codex-sidepanel',
  CODEX_SIDEPANEL_ARROWS: 'codex-sidepanel-arrows',
  CODEX_SIDEPANEL_DIRECT: 'codex-sidepanel-direct',
  CODEX_BOOK_SWITCHER: 'codex-book-switcher',
  CODEX_LINKAREA: 'codex-linkarea',
  CODEX_DIALOG: 'codex-dialog',
} as const;

type ValuesOfObject<T extends Record<string, string>> = T[keyof T];

export type AnalyticsData = {
  locationId: ValuesOfObject<typeof ANALYTICS_EVENT_LOCATIONS>;
  subLocationId: ValuesOfObject<typeof ANALYTICS_EVENT_SUBLOCATIONS>;
};
